<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" href="#tabs-2-tab-1" role="tab" data-toggle="tab">
						<span class="nav-link-in">
							Terminais Vinculados
							<i class="fa fa-bulding"></i>
						</span>
					</a>
				</li>
			</ul>

			<div class="tab-content">
				<div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" id="tabs-2-tab-1">
                        <table class="table-striped" id="mais">
                            <thead>
                                <tr>
                                    <th style="width: 20%">Código</th>
                                    <th style="width: 20%">Descrição</th>
                                    <th style="width: 20%">Código ANTAQ</th>
                                    <th style="width: 15%">Código ERP</th>
                                    <th style="width: 20%">Status</th>
                                    <th style="width: 5%">Ações</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.terminal">
                                    <td>
                                        {{ item.cd }}
                                    </td>
                                    <td>
                                        {{ item.descr }}
                                    </td>
                                    <td>
                                        {{ item.cd_antaq }}
                                    </td>
                                    <td>
                                        {{ item.cd_erp }}
                                    </td>
                                    <td>
                                        <span class="label label-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                        <span class="label label-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                    </td>
                                    <td>
                                        <a v-if="item.status.valor==2" @click="onActivateDesactivate(1, item, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                        <a v-if="item.status.valor==1" @click="onActivateDesactivate(2, item, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                        <a @click="onEditTerminal(item)" v-b-tooltip title="Alterar"><i class="fa fa-edit"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
</template>

  <script>
  export default {
      data () {
        return {
          helpForm: new Form({recordCollection: [], status: ''}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
        onEditTerminal(data) {
            Event.$emit('editTerminal', data);
        },
        onActivateDesactivate(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {

                this.helpForm.recordCollection = [];
                this.helpForm.recordCollection.push(data.terminal_id );
            }
            else
            {
                this.helpForm.recordCollection = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.recordCollection.push(obj)
                });
            }
            this.helpForm.patch('/api/porto/terminal/status').then(response =>
            {
                new ReturnApi(response, this);
                this.$events.fire('filter-reset');
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
    },
  }
  </script>
